/* tslint:disable */
/* eslint-disable */
/**
 * ROC API
 * Referral Outbound Center (ROC) API for managing outbound referrals between post-acute care facilities.  All endpoints require a valid JWT. Organization and user identity are derived from the token — callers never pass these in query params or request bodies. 
 *
 * The version of the OpenAPI document: 0.2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DocumentUploadUrl
 */
export interface DocumentUploadUrl {
    /**
     * 
     * @type {string}
     * @memberof DocumentUploadUrl
     */
    signed_url: string;
    /**
     * ROC bucket key to pass to createDocument after the browser upload completes.
     * @type {string}
     * @memberof DocumentUploadUrl
     */
    source_blob_s3_key: string;
    /**
     * 
     * @type {number}
     * @memberof DocumentUploadUrl
     */
    expires_in_seconds: number;
}

/**
 * Check if a given object implements the DocumentUploadUrl interface.
 */
export function instanceOfDocumentUploadUrl(value: object): value is DocumentUploadUrl {
    if (!('signed_url' in value) || value['signed_url'] === undefined) return false;
    if (!('source_blob_s3_key' in value) || value['source_blob_s3_key'] === undefined) return false;
    if (!('expires_in_seconds' in value) || value['expires_in_seconds'] === undefined) return false;
    return true;
}

export function DocumentUploadUrlFromJSON(json: any): DocumentUploadUrl {
    return DocumentUploadUrlFromJSONTyped(json, false);
}

export function DocumentUploadUrlFromJSONTyped(json: any, ignoreDiscriminator: boolean): DocumentUploadUrl {
    if (json == null) {
        return json;
    }
    return {
        
        'signed_url': json['signed_url'],
        'source_blob_s3_key': json['source_blob_s3_key'],
        'expires_in_seconds': json['expires_in_seconds'],
    };
}

export function DocumentUploadUrlToJSON(json: any): DocumentUploadUrl {
    return DocumentUploadUrlToJSONTyped(json, false);
}

export function DocumentUploadUrlToJSONTyped(value?: DocumentUploadUrl | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'signed_url': value['signed_url'],
        'source_blob_s3_key': value['source_blob_s3_key'],
        'expires_in_seconds': value['expires_in_seconds'],
    };
}

